export default function PrivacyPolicy({ onBack }) {
  return (
    <div style={s.wrap}>
      <div style={s.container}>
        <button style={s.backBtn} onClick={onBack}>← Back</button>

        <h1 style={s.title}>Privacy Policy</h1>
        <p style={s.updated}>Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>

        <Section title="Overview">
          <p style={s.p}>
            RBXWar ("we", "us", "our") provides an automated pricing tool for Roblox limited items.
            This policy explains how your information is stored and used. By using RBXWar, you agree
            to the practices described below.
          </p>
        </Section>

        <Section title="Your Security">
          <p style={s.p}>
            Your Roblox <code style={s.code}>.ROBLOSECURITY</code> cookie and 2FA secret are{" "}
            <b style={{color:"var(--rbx-accent, #38bdf8)"}}>encrypted before being stored</b>, never saved in plain text.
            Access is limited to what's required to run your bot on your behalf, and your cookie is
            masked (shown as <code style={s.code}>***</code>) anywhere it would otherwise be displayed
            back to you in the dashboard.
          </p>
          <p style={s.p}>
            Because losing your license key would otherwise mean losing access to your account, every
            account gets a recovery phrase the first time it's activated, a secondary credential you
            can use to log back in if you ever lose your key.
          </p>
          <p style={s.p}>
            All traffic between your browser and our servers is encrypted in transit via HTTPS/TLS.
          </p>
        </Section>

        <Section title="How Your Cookie Is Used">
          <p style={s.p}>
            Your <code style={s.code}>.ROBLOSECURITY</code> cookie is used exclusively to authenticate
            as your Roblox account when the bot runs: logging in, checking your inventory, reading
            resale listings, and updating item prices. It is never sold, shared with third parties, or
            used for any purpose outside operating the service you signed up for.
          </p>
        </Section>

        <Section title="How Your 2FA Secret Is Used">
          <p style={s.p}>
            If you choose to provide a 2FA secret, it's used solely to generate the same rotating
            authentication codes your authenticator app would generate, so the bot can complete
            Roblox's two-factor verification automatically during login and sensitive actions (like
            listing an item). It is never transmitted anywhere besides Roblox's own verification
            endpoints.
          </p>
        </Section>

        <Section title="Data Retention & Deletion">
          <p style={s.p}>
            Your data is retained for as long as your account remains active. If you remove a Roblox
            account from your dashboard, its cookie and associated data are deleted from our database.
            If you'd like your entire account and all associated data permanently deleted, contact us
            (see below) and we'll process the request promptly.
          </p>
        </Section>

        <Section title="Third Parties">
          <p style={s.p}>
            We use Rolimons and RoUtility's public APIs to fetch item values and RAP data, and Roblox's
            own public APIs to check inventories, resale listings, and process transactions. We don't
            share your account data with any other third party, and we don't run ads or sell data to
            advertisers.
          </p>
        </Section>

        <Section title="Changes to This Policy">
          <p style={s.p}>
            We may update this policy from time to time as the service evolves. Material changes will
            be reflected by updating the date at the top of this page.
          </p>
        </Section>

        <Section title="Contact">
          <p style={s.p}>
            Questions about this policy or your data? Our{" "}
            <a href="https://discord.gg/683FrRFgsK" target="_blank" rel="noopener noreferrer" style={s.link}>Discord server</a>{" "}
            is the only place we offer support. Join and open a ticket there.
          </p>
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={s.section}>
      <h2 style={s.h2}>{title}</h2>
      {children}
    </div>
  );
}

const s = {
  wrap:      { minHeight: "calc(100vh / var(--ui-zoom, 1))", background: "#080808", color: "#fff", fontFamily: "'Rubik','Inter',sans-serif", padding: "48px 24px" },
  container: { maxWidth: 720, margin: "0 auto" },
  backBtn:   { background: "none", border: "1px solid #222", color: "#888", borderRadius: 8, padding: "8px 16px", fontSize: 13, cursor: "pointer", marginBottom: 32, fontFamily: "inherit" },
  title:     { fontSize: 36, fontWeight: 800, margin: "0 0 8px", fontFamily: "'Khaviax', sans-serif" },
  updated:   { color: "#555", fontSize: 13, marginBottom: 40 },
  section:   { marginBottom: 32 },
  h2:        { fontSize: 18, fontWeight: 700, color: "var(--rbx-accent, #38bdf8)", marginBottom: 12, fontFamily: "'Moderniz', sans-serif" },
  p:         { color: "#aaa", fontSize: 14.5, lineHeight: 1.75, margin: "0 0 12px" },
  list:      { color: "#aaa", fontSize: 14.5, lineHeight: 1.9, paddingLeft: 20, margin: 0 },
  code:      { background: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: 4, padding: "1px 6px", fontFamily: "monospace", fontSize: 13, color: "var(--rbx-accent, #38bdf8)" },
  link:      { color: "var(--rbx-accent, #38bdf8)", textDecoration: "none" },
};
